import React from "react";
import { SvgIcon } from "@material-ui/core";

import { ReactComponent as TrafficJam } from "src/assets/svg/traffic-jam.svg";
import { ReactComponent as Accept } from "src/assets/svg/accept.svg";
import { ReactComponent as Car } from "src/assets/svg/car.svg";
import { ReactComponent as Contract } from "src/assets/svg/contract.svg";
import { ReactComponent as Invoice } from "src/assets/svg/invoice.svg";
import { ReactComponent as CarDocument } from "src/assets/svg/cardocument.svg";
import { ReactComponent as Camera } from "src/assets/svg/camera.svg";
import { ReactComponent as Documentation } from "src/assets/svg/documentation.svg";
import { ReactComponent as Diary } from "src/assets/svg/diary.svg";
import { ReactComponent as TollRoad } from "src/assets/svg/toll-road.svg";

export const TrafficJamIcon = (props) => (
  <SvgIcon {...props} component={TrafficJam} viewBox="0 0 512 512" />
);
export const AcceptIcon = (props) => (
  <SvgIcon {...props} component={Accept} viewBox="0 0 512 512" />
);
export const CarIcon = (props) => (
  <SvgIcon {...props} component={Car} viewBox="0 0 488.001 488.001" />
);
export const ContractIcon = (props) => (
  <SvgIcon {...props} component={Contract} viewBox="0 0 512 512" />
);
export const InvoiceIcon = (props) => (
  <SvgIcon {...props} component={Invoice} viewBox="0 0 480 480" />
);
export const CarDocumentIcon = (props) => (
  <SvgIcon {...props} component={CarDocument} viewBox="0 0 436 436" />
);
export const CameraIcon = (props) => <SvgIcon {...props} component={Camera} viewBox="0 0 50 50" />;
export const DocumentationIcon = (props) => (
  <SvgIcon {...props} component={Documentation} viewBox="0 0 100 100" />
);
export const DiaryIcon = (props) => <SvgIcon {...props} component={Diary} viewBox="0 0 512 512" />;
export const TollRoadIcon = (props) => (
  <SvgIcon {...props} component={TollRoad} viewBox="0 0 60 60" />
);
